import { render, staticRenderFns } from "./IndexPhone.vue?vue&type=template&id=185dba36&scoped=true&"
import script from "./IndexPhone.vue?vue&type=script&lang=js&"
export * from "./IndexPhone.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/bootstrap.min.css?vue&type=style&index=0&id=185dba36&scoped=true&lang=css&"
import style1 from "./IndexPhone.vue?vue&type=style&index=1&id=185dba36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185dba36",
  null
  
)

export default component.exports